// Shared by the client guard and the server checks; no `node:crypto` here so
// the client bundle can import it.

// Hidden decoy input, named so a form-filling bot wants to populate it.
export const HONEYPOT_FIELD = "website";

export const FORM_TOKEN_ENDPOINT = "/api/form-token/";

// Fastest a human plausibly fills a booking form. Bots post instantly.
export const MIN_FILL_MS = 3_000;

// Bounds token replay. Generous because the booking drawer can sit open.
export const MAX_TOKEN_AGE_MS = 24 * 60 * 60 * 1000;
